import React from "react";
import { Icon, SelectInput, Spinner } from "asocomponents"
import DocumentoService from "../../../../../modules/Documentos/application/DocumentoService";
import useFetch from "../../../../hooks/useFetch";

function SelectTipoDocumentoObservacion({ onChange, width }) {

    const docService = new DocumentoService()

    const { isLoading, data, isFailed } = useFetch(
        docService,
        "getTiposDocumento"
    )


    if (isLoading) {
        return <Spinner color="red" size="10" />
    }

    if (isFailed) {
        return <Icon type="error" />
    }

    return (
        <div>
            <SelectInput options={data} placeholder="Tipo Documento" todos={false} onChange={onChange} defaultValue="-2" width={width} valueField="tipoDocumento"></SelectInput>
        </div>
    )
}

export default SelectTipoDocumentoObservacion